<template>
  <v-card class="elevation-0">
    <loading-block class="pt-8" v-if="!loaded"></loading-block>
    <v-row v-else>
      <v-col cols="12" sm="12" md="4" lg="4">
        <div style="max-height: 320px; max-width:320px;">
          <img
            v-if="activeItem.image"
            style="width: 100%; height: auto;"
            class="detail-image pa-5"
            :src="activeItem.image"
          />
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on:click.prevent="deleteItem(activeItem)"
              v-on="on"
              small
              dark
              color="primary"
              class="abs-rt"
              depressed
            >Delete</v-btn>
          </template>
          <span>DELETE</span>
        </v-tooltip>

        <h2 class="mb-0 font-weight-medium pr-4">{{ activeItem.name }}</h2>
        <p class="mb-0 subheading font-weight-medium">{{ getBrandName(activeItem.brand_id) }}</p>
        <p class="mb-4">{{ activeItem.street_name }}</p>
        <p class="mb-0">
          <v-switch
            @change="updateActiveItem"
            v-model="activeItem.discontinued"
            name="Discontinued"
            label="Discontinued"
            color="primary"
            class="reverse-position mt-0"
          ></v-switch>
          <v-switch
            @change="updateActiveItem"
            v-model="activeItem.featured"
            name="Featured"
            label="Featured"
            color="primary"
            class="reverse-position mt-0"
          ></v-switch>
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ProductAPI } from '@/clients/product/product.api'
import { BrandAPI } from '@/clients/product/brand.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      brandList: []
    }
  },
  async mounted() {
    this.loaded = false
    const brandData = await BrandAPI.brandList()
    this.brandList = brandData.data.payload
    this.loaded = true
  },
  computed: {
    ...mapGetters({
      activeItem: 'product/activeItem'
    })
  },
  methods: {
    /**
    * Get brand name from brand id
    */
    getBrandName(brandId) {
      if (!brandId) return

      let mybrand = this.brandList.filter(item => item.id === brandId)
      return mybrand[0].name
    },

    /**
     * Update active item single value
     */
    async updateActiveItem(val) {
      try {
        // console.log(this.activeItem)
        this.spinner(true)
        // we dont have single api to need to pass all like edit
        let res = await ProductAPI.edit(this.activeItem.id, {
          brand_id: this.activeItem.brand_id,
          category_id: this.activeItem.category_id,
          name: this.activeItem.name,
          street_name: this.activeItem.street_name,
          description: this.activeItem.description,
          usage_instructions: this.activeItem.usage_instructions,
          discontinued: this.activeItem.discontinued,
          product_type: this.activeItem.product_type,
          weighing_unit: this.activeItem.weighing_unit,
          shelf_life_unit: this.activeItem.shelf_life_unit,
          shelf_life: this.activeItem.shelf_life,
          order: this.activeItem.order,
          featured: this.activeItem.featured,
          product_family: this.activeItem.product_family
        })
        if (res.status === 200) {
          this.setActiveItem(res.data.payload)
          // bus.$emit('updated-featured-discontinue-switch', res.data.payload)
        }
        this.spinner(false)
        // Display message alert
        this.snackbar({
          text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
          open: true,
          color: res.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    },

    /**
    * Function accept object which has an id, return confirm then delete the category
    */
    deleteItem(obj) {
      document.activeElement.blur()
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${obj.name}.`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: '#db563f',
        cancelButtonColor: '#f14409',
        confirmButtonText: 'DELETE',
        cancelButtonText: 'CANCEL'
      }).then(async function (result) {
        if (result.value) {
          try {
            self.spinner(true)
            let res = await ProductAPI.delete(obj.id)
            self.spinner(false)
            if (res.status === 200) {
              self.setEditPop(false)
              self.setSectionType('list')
              self.setActiveItem({})
              self.$swal(
                'Deleted!',
                `${obj.name} successfully deleted.`,
                'success'
              )
            } else {
              self.$swal(
                'Failed!',
                'Please try again later.',
                'error'
              )
            }
          } catch (err) {
            self.spinner(false)
            self.snackbar({
              text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
              open: true,
              color: 'error'
            })
          }
        }
      })
    },
    ...mapActions({
      setEditPop: 'product/setEditPop',
      setActiveItem: 'product/setActiveItem',
      setSectionType: 'product/setSectionType'
    })
  }
}
</script>
<style scoped>
.abs-rt {
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>
